import Fire from "@/models/fire";

export interface RawUser {
  avatar: string;
  name: string;
  phone: string;
  group?: string;
}

export default class UserModel {
  private static getRef() {
    const db = Fire.getFireStoreDb();
    return db.collection("users");
  }

  public static async getUserProfile(phone: string): Promise<RawUser> {
    const db = this.getRef();
    const doc = await db.doc(phone).get();

    if (doc.exists) {
      return doc.data() as RawUser;
    }

    return this.initUserProfile(phone);
  }

  private static async initUserProfile(phone: string): Promise<RawUser> {
    const db = this.getRef();
    const defaultUserProfile: RawUser = {
      avatar: "",
      name: "",
      phone
    };
    await db.doc(phone).set(defaultUserProfile);
    return defaultUserProfile;
  }

  public static async changeAvatar(uid: string, imageUrl: string) {
    const db = this.getRef();
    return db.doc(uid).update({
      avatar: imageUrl
    });
  }
}
